module.exports = __webpack_public_path__ + "static/media/7cricketlogo.bc99b675.png";